const azureTables = {
    MERLINASSISTROASTERINFO : process.env.REACT_APP_MERLINASSISTROASTERINFO_TABLE,
    MERLINASSISTUSERANDTENANT: process.env.REACT_APP_MERLINASSISTUSERANDTENANT_TABLE,
    MERLINASSISTREGIONSTORE:  process.env.REACT_APP_MERLINASSISTREGIONSTORE_TABLE,
    MERLINASSISTROASTERINFOV1: process.env.REACT_APP_MERLINASSISTROASTERINFO_TABLE_V1,
    MERLINASSISTREGIONSTOREV1:  process.env.REACT_APP_MERLINASSISTREGIONSTORE_TABLE_V1,
 }

 export default azureTables;